module.exports = __webpack_public_path__ + "static/media/homeMenuActive.7e2e4cdd.svg";